(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-heyshape-allinone"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   collection-heyshape-style.js
   Filtres AJAX (Section Rendering API), drawer mobile, tri, quick add, read more.
   JS vanilla, défensif, sans dépendance.
   ========================================================================== */
(function () {
  function initCollection(root) {
    var sectionId = root.getAttribute('data-section-id');
    var collectionUrl = root.getAttribute('data-collection-url');
    var resultsEl = root.querySelector('[data-hs-results]');
    var filtersEl = root.querySelector('[data-hs-filters]');
    var form = root.querySelector('[data-hs-facets]');
    var sortSelect = root.querySelector('[data-hs-sort]');
    var aside = root.querySelector('[data-hs-aside]');
    var overlay = root.querySelector('[data-hs-overlay]');
    var openBtn = root.querySelector('[data-hs-filter-open]');
    var closeBtn = root.querySelector('[data-hs-filter-close]');
    var applyBtn = root.querySelector('[data-hs-filter-apply]');
    var clearBtn = root.querySelector('[data-hs-filter-clear]');
    var controller = null;
    /* ---------- Drawer mobile ---------- */
    function openDrawer() {
      if (!aside) return;
      aside.classList.add('is-open');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('hs-no-scroll');
      aside.setAttribute('aria-hidden', 'false');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      if (!aside) return;
      aside.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('hs-no-scroll');
      aside.setAttribute('aria-hidden', 'true');
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeDrawer();
    });
    /* ---------- Construction des paramètres ---------- */
    function buildParams() {
      var params = new URLSearchParams();
      if (form) {
        var fd = new FormData(form);
        fd.forEach(function (value, key) {
          if (value !== '' && value != null) params.append(key, value);
        });
      }
      if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
      return params;
    }
    /* ---------- Rendu AJAX ---------- */
    function render(paramsString, updateHistory, doScroll) {
      var newUrl = collectionUrl + (paramsString ? '?' + paramsString : '');
      var fetchUrl =
        collectionUrl + '?section_id=' + sectionId + (paramsString ? '&' + paramsString : '');
      if (controller) controller.abort();
      controller = new AbortController();
      root.classList.add('hs-loading');
      fetch(fetchUrl, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newResults = doc.querySelector('[data-hs-results]');
          var newFilters = doc.querySelector('[data-hs-filters]');
          if (newResults && resultsEl) resultsEl.innerHTML = newResults.innerHTML;
          if (newFilters && filtersEl) filtersEl.innerHTML = newFilters.innerHTML;
          if (updateHistory) window.history.pushState({ hs: true }, '', newUrl);
          root.classList.remove('hs-loading');
          if (doScroll && resultsEl) {
            var top = resultsEl.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          root.classList.remove('hs-loading');
          window.location.href = newUrl;
        });
    }
    function applyFromForm(updateHistory) {
      render(buildParams().toString(), updateHistory !== false, false);
    }
    /* ---------- Écouteurs filtres + tri ---------- */
    if (form) form.addEventListener('change', function () { applyFromForm(true); });
    if (sortSelect) sortSelect.addEventListener('change', function () { applyFromForm(true); });
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (form) form.reset();
        var p = new URLSearchParams();
        if (sortSelect && sortSelect.value) p.set('sort_by', sortSelect.value);
        render(p.toString(), true, false);
      });
    }
    /* ---------- Pagination + chips de filtres actifs (délégation) ---------- */
    root.addEventListener('click', function (e) {
      var link = e.target.closest('a.js-hs-ajax');
      if (!link) return;
      e.preventDefault();
      var href = link.getAttribute('href') || '';
      var qs = href.indexOf('?') > -1 ? href.split('?')[1] : '';
      render(qs, true, true);
    });
    /* ---------- Quick add ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hs-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
          /* Hooks panier (Shrine/Dawn) : adapte si besoin au cart drawer du thème */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          var bus = document.querySelector('cart-drawer');
          if (bus && typeof bus.open === 'function') { try { bus.open(); } catch (e2) {} }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          window.location.href = '/cart';
        });
    });
    /* ---------- Aperçu couleur : change l'image au clic sur une pastille ---------- */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-hs-swatch]');
      if (!sw) return;
      var img = sw.getAttribute('data-img');
      if (!img) return;
      var card = sw.closest('.hs-card');
      if (!card) return;
      var primary = card.querySelector('.hs-card__img--primary');
      if (!primary) return;
      primary.removeAttribute('srcset');
      primary.removeAttribute('sizes');
      primary.src = img;
      var bg = card.querySelector('[data-hs-bg]');
      if (bg) bg.style.backgroundImage = "url('" + img + "')";
      var sibs = sw.parentNode.querySelectorAll('[data-hs-swatch]');
      for (var i = 0; i < sibs.length; i++) { sibs[i].classList.remove('is-active'); }
      sw.classList.add('is-active');
    });
    /* ---------- Read more (intro + SEO) ---------- */
    root.querySelectorAll('[data-hs-readmore]').forEach(function (t) {
      t.addEventListener('click', function () {
        var target = root.querySelector(t.getAttribute('data-target'));
        if (!target) return;
        var expanded = target.classList.toggle('is-expanded');
        target.classList.toggle('is-collapsed', !expanded);
        t.setAttribute('aria-expanded', String(expanded));
        t.textContent = expanded
          ? (t.getAttribute('data-less') || 'Voir moins')
          : (t.getAttribute('data-more') || 'Voir plus');
      });
    });
    /* ---------- Back / forward navigateur ---------- */
    window.addEventListener('popstate', function () {
      var qs = window.location.search.replace(/^\?/, '');
      render(qs, false, false);
    });
  }
  function boot() {
    document.querySelectorAll('[data-hs-collection]').forEach(initCollection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
